import {
  Component,
  ElementRef,
  ViewChild,
  effect,
} from '@angular/core';
import { ToastService } from 'src/app/core/services/toast.service';

@Component({
  selector: 'vee-alert-container',
  templateUrl: './alert-container.component.html',
  styleUrls: ['./alert-container.component.scss'],
  standalone: false,
})
export class AlertContainerComponent {
  @ViewChild('container') private containerRef?: ElementRef<HTMLDivElement>;

  constructor(public toastService: ToastService) {
    /* Toasts must render above an open native <dialog> (shown via
     * showModal(), which places it in the browser's top layer — no
     * z-index from outside that layer can ever beat it, no matter how
     * high). The popover API puts this container in that same top layer;
     * since it's (re)shown whenever a toast appears, it stacks above any
     * dialog already open at that point. */
    effect(() => {
      const hasAlerts = this.toastService.alerts().length > 0;
      const el = this.containerRef?.nativeElement;
      if (!el) return;
      if (hasAlerts && !el.matches(':popover-open')) {
        el.showPopover();
      } else if (!hasAlerts && el.matches(':popover-open')) {
        el.hidePopover();
      }
    });
  }
}
